import { Container, Row, Col, Nav, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./footer.css";
import {
    AusFlag,
    facebook,
    IndianFlag,
    instagram,
    linkedin,
    USAFlag,
    youtube,
} from "../../assets/common/common";
import acubebrochure from "../../assets/Acube-brochure.pdf";

const year = new Date().getFullYear();

function Footer() {
    const navigate = useNavigate();

    const hireTeamUrlRouting = [
        { pathname: "/services/hire_reactjs_developer", pageName: "Hire a Full Stack Developer" },
        { pathname: "/services/hire_ios_developer", pageName: "Hire an IOS Developer" },
        { pathname: "/services/hire_android_developer", pageName: "Hire an Android Developer" },
        { pathname: "/services/hire_reactjs_developer", pageName: "Hire a Front End Developer" },
        { pathname: "/services/hire_Nodejs_developer", pageName: "Hire a Backend Developer" },
        { pathname: "/services/hire_rpa_developer", pageName: "Hire a RPA Developer" },
        { pathname: "/services/hire_AWS_Cloud_developer", pageName: "Hire a Cloud Architect" },
        { pathname: "/services/hire_blockchain_developer", pageName: "Hire a Blockchain Developer" },
        { pathname: "/services/artificial_intelligence", pageName: "Hire an AI Developer" },
        { pathname: "/services/hire_devops_engineer", pageName: "Hire a DevOps Professional" },
    ];

    const servicesUrlRouting = [
        { pathname: "/services/ios_app", pageName: "IOS Mobile App Development" },
        { pathname: "/services/android_app", pageName: "Android Mobile App Development" },
        { pathname: "/services/web_app", pageName: "Web Application Development" },
        { pathname: "/services/cloud_strategy", pageName: "Cloud Strategy & Development" },
        { pathname: "/services/blockchain_app", pageName: "Blockchain Applications" },
        { pathname: "/services/robotic_process_automation", pageName: "Robotic Process Automation" },
        { pathname: "/services/iot_app", pageName: "Internet of Things(IoT)" },
        { pathname: "/services/machine_learning", pageName: "Machine Learning" },
        { pathname: "/services/business_intelligence", pageName: "Business Intelligence" },
        { pathname: "/services/artificial_intelligence", pageName: "Artificial Intelligence" },

    ];


    const handleNavigate = (serviceName) => {
        const matchingRoute =
            hireTeamUrlRouting.find((route) => route.pageName === serviceName) ||
            servicesUrlRouting.find((route) => route.pageName === serviceName);

        if (matchingRoute) {
            navigate(matchingRoute.pathname);
        }
    };

    const renderLinks = (services) => {
        return services.map((service, index) => (
            <li key={index} className="fw-normal mb-2">
                <Nav.Link onClick={() => handleNavigate(service)}>
                    {service}
                </Nav.Link>
            </li>
        ));
    };

    const servicesLeft = [
        "Hire a Full Stack Developer",
        "Hire an IOS Developer",
        "Hire an Android Developer",
        "Hire a Front End Developer",
        "Hire a Backend Developer",
    ];

    const servicesRight = [
        "Hire a RPA Developer",
        "Hire a Cloud Architect",
        "Hire a Blockchain Developer",
        "Hire an AI Developer",
        "Hire a DevOps Professional",
    ];

    const servicesLeftTwo = [
        "IOS Mobile App Development",
        "Android Mobile App Development",
        "Web Application Development",
        "Cloud Strategy & Development",
        "Blockchain Applications",
    ];

    const servicesRightTwo = [
        "Robotic Process Automation",
        "Internet of Things(IoT)",
        "Machine Learning",
        "Business Intelligence",
        "Artificial Intelligence",
    ];

    return (
        <footer className="footer">
            <Container fluid>
                <Row className="mb-5">
                    <Col xs="12" lg="6">
                        <p className="mb-3 ft-wt-600 ft-24">Our Services</p>
                        <div className="d-flex flex-wrap gap-3 text-white">
                            <ul>{renderLinks(servicesLeft)}</ul>
                            <ul>{renderLinks(servicesRight)}</ul>
                        </div>
                    </Col>
                    <Col xs="12" lg="6">
                        <p className="mb-3 ft-wt-600 ft-24">Our Expertise</p>
                        <div className="d-flex flex-wrap gap-3 text-white">
                            <ul>{renderLinks(servicesLeftTwo)}</ul>
                            <ul>{renderLinks(servicesRightTwo)}</ul>
                        </div>
                    </Col>
                    <Col xs="12" className="mt-3">
                        <h5 className="text-white mb-0 d-flex gap-2 align-items-center flex-wrap">
                            <span>
                                <a
                                    href="mailto:info@acubetechnologies.in"
                                    className="text-white fw-normal"
                                >
                                    info@acubetechnologies.in
                                </a>
                            </span>{" "}
                            |
                            <span>
                                <a
                                    href="mailto:sales@acubetechnologies.in"
                                    className="text-white fw-normal"
                                >
                                    sales@acubetechnologies.in
                                </a>
                            </span>{" "}
                            |
                            <span>
                                <a
                                    href="mailto:hr-support@acubetechnologies.in"
                                    className="text-white fw-normal"
                                >
                                    hr-support@acubetechnologies.in
                                </a>
                            </span>
                        </h5>
                    </Col>
                </Row>
                <Row className="footer-addresses">
                    <Col xs="12" md="6" className="pb-3 pb-lg-0">
                        <Row className="gap-3 gap-lg-0">
                            <Col xs="12" className="text-center text-lg-start">
                                <p className="mb-4 ft-wt-600 ft-24">Global Presence</p>
                            </Col>
                            <Col xs="12" xl="6">
                                <div className="address-item">
                                    <div className="flag-circle">
                                        <img src={USAFlag} alt="USA Flag" loading="lazy" />
                                    </div>
                                    <div className="address-info">
                                        <p className="fw-normal ft-24">ACube USA LLC</p>
                                        <h5>
                                            401 Ryland St. STE 200-A,<br></br> Reno, WASHOE COUNTY,
                                            <br></br> NV 89502 USA
                                        </h5>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="12" xl="6">
                                <div className="address-item">
                                    <div className="flag-circle">
                                        <img src={AusFlag} alt="Aus Flag" loading="lazy" />
                                    </div>
                                    <div className="address-info">
                                        <p className="fw-normal ft-24">Australia</p>
                                        <h5>
                                            ACubetech solutions<br></br> Engenesis Level 14, <br></br>
                                            275 Alfred Street North Sydney,<br></br> New South Wales
                                            2060<br></br> Australia 02 91880844
                                        </h5>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="12" md="6" className="mt-4 mt-md-0 pb-3 pb-lg-0">
                        <Row className="gap-3 gap-lg-0">
                            <Col xs="12" className="text-center text-lg-start">
                                <p className="mb-4 ft-wt-600 ft-24">
                                    Offices and Development Centers
                                </p>
                            </Col>
                            <Col xs="12" xl="6">
                                <div className="address-item">
                                    <div className="flag-circle">
                                        <img src={IndianFlag} alt="India Flag" loading="lazy" />
                                    </div>
                                    <div className="address-info">
                                        <p className="fw-normal ft-24">Bangalore</p>
                                        <h5>
                                            ACubetech solutions Pvt Ltd<br></br>Brigade IRV, 3rd
                                            Floor.<br></br>Nellurhalli, Whitefield,<br></br>Bangalore
                                            - 560066, India.
                                        </h5>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="12" xl="6">
                                <div className="address-item">
                                    <div className="flag-circle">
                                        <img src={IndianFlag} alt="India Flag" loading="lazy" />
                                    </div>
                                    <div className="address-info">
                                        <p className="fw-normal ft-24">Chennai</p>
                                        <h5>
                                            ACubetech solutions Pvt Ltd<br></br>Akshaya CUBE, 6th
                                            Floor.<br></br>OMR Thoraipakkam, Near BSR Mall,<br></br>
                                            Chennai - 600096, India.
                                        </h5>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="gap-3 gap-lg-0">
                    <Col xs="12" className="text-center text-lg-start">
                        <p className="mb-4 ft-wt-600 ft-24">On-Call Support</p>
                    </Col>
                    <Col xs="12" lg="8" xl="10">
                        <Row className=" gap-5 gap-xl-0">
                            <Col xs="12" xl="4">
                                <div className="d-flex align-items-center gap-3 justify-content-start h-100">
                                    <div className="flag-circle">
                                        <img src={USAFlag} alt="USA Flag" loading="lazy" />
                                    </div>
                                    <div className="address-info">
                                        <a href="tel:+17026054713">
                                            <h4>+1 (702) 605-4713</h4>
                                        </a>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="12" xl="4">
                                <div className="d-flex align-items-center gap-3 justify-content-start w-100">
                                    <div className="flag-circle">
                                        <img src={IndianFlag} alt="India Flag" loading="lazy" />
                                    </div>
                                    <div className="address-info w-100">
                                        <div className="d-flex align-items-center gap-3 mb-4 mb-lg-2 w-100 flex-wrap">
                                            <p className="ft-wt-600 mb-0" style={{ maxWidth: "120px", width: "100%" }}>Sales Team:</p>
                                            <a href="tel:+917899150871" className=" mb-0"><h4 className="mb-0">+91 7899 150 871</h4></a>
                                        </div>
                                        <div className="d-flex align-items-center gap-3 mb-0 w-100 flex-wrap">
                                            <p className="ft-wt-600 mb-0" style={{ maxWidth: "120px", width: "100%" }}>HR Team:</p>
                                            <a href="tel:+919686077111" className=""><h4 className="mb-0">+91 9686 077 111</h4></a>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <hr className="footer-divider" />
                <Row className="footer-bottom align-items-center gap-4 gap-lg-0">
                    <Col xs="12" lg="3">
                        <div className="social-icons justify-content-center justify-content-lg-start">
                            <a
                                href="https://www.linkedin.com/company/acubetech-solutions-private-limited/mycompany/?viewAsMember=true"
                                rel="noreferrer"
                                target="_blank"
                                className="social-icon"
                            >
                                <img src={linkedin} alt="linkedin" loading="lazy" />
                            </a>
                            <a
                                href="https://www.instagram.com/acubetech/"
                                className="social-icon"
                                rel="noreferrer"
                                target="_blank"
                            >
                                <img src={instagram} alt="instagram" loading="lazy" />
                            </a>
                            <a
                                href="https://www.youtube.com/@acubetechnologies"
                                className="social-icon"
                                rel="noreferrer"
                                target="_blank"
                            >
                                <img src={youtube} alt="youtube" loading="lazy" />
                            </a>
                            <a
                                href="https://www.facebook.com/Acubetech/"
                                className="social-icon"
                                rel="noreferrer"
                                target="_blank"
                            >
                                <img src={facebook} alt="facebook" loading="lazy" />
                            </a>
                        </div>
                    </Col>
                    <Col xs="12" lg="6" className="text-center">
                        <h5 className="mb-0 fw-normal opacity-70">
                            Copyright © {year} Acube. All Rights Reserved. Privacy Policy
                        </h5>
                    </Col>
                    <Col xs="12" lg="3" className="text-center text-lg-end">
                        {/* <a href="https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/pdf/Acube-brochure.pdf"
                            download
                            target="_blank"
                            rel="noopener noreferrer">
                            <Button variant="secondary" className="text-uppercase w-auto">Download Brochure</Button>
                        </a> */}
                        <a
                            href={acubebrochure}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button variant="secondary" className="text-uppercase w-auto">
                                Download Brochure
                            </Button>
                        </a>

                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
